import { setTranslations, setDefaultLanguage } from 'react-multi-lang'

import fr from './fr.json'
 
setTranslations({
  fr,
})

setDefaultLanguage('fr')
